//VALIDACIONES DE YUP:
import * as yup from 'yup';

export const aboutSchema = yup.object().shape({
	category: yup
		.string()
		.trim()
		.required('La categoría es obligatoria.')
		.max(50, 'La categoría no puede superar los 50 caracteres.'),
	title: yup
		.string()
		.trim()
		.required('El título es obligatorio.')
		.max(50, 'El título no puede superar los 50 caracteres.'),
	description: yup
		.string()
		.trim()
		.required('La descripción es obligatoria.')
		.max(2000, 'La descripción no puede superar los 2000 caracteres.'),
});

export const bdcSchema = yup.object().shape({
	category: yup
		.string()
		.trim()
		.required('La categoría es obligatoria.')
		.max(50, 'La categoría no puede superar los 50 caracteres.'),
	title: yup
		.string()
		.trim()
		.required('El título es obligatorio.')
		.max(50, 'El título no puede superar los 50 caracteres.'),
	description: yup
		.string()
		.trim()
		.required('La descripción es obligatoria.')
		.max(2000, 'La descripción no puede superar los 2000 caracteres.'),
});

export const projectSchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.required('El nombre es obligatorio.')
		.max(50, 'El nombre no puede superar los 50 caracteres.'),

	title: yup
		.string()
		.trim()
		.max(50, 'El título no puede superar los 50 caracteres.')
		.nullable(),

	description: yup
		.string()
		.trim()
		.required('La descripción es obligatoria.')
		.max(5000, 'La descripción no puede superar los 5000 caracteres.'),

	external_video: yup
		.string()
		.trim()
		.max(1000, 'El vídeo externo no puede superar los 1000 caracteres.')
		.nullable(),

	external_link: yup
		.string()
		.trim()
		.url('El enlace externo debe ser una URL válida.')
		.max(250, 'El enlace externo no puede superar los 250 caracteres.')
		.nullable(),

	external_link_name: yup
		.string()
		.trim()
		.max(
			50,
			'El nombre del enlace externo no puede superar los 50 caracteres.'
		)
		.nullable(),

	bandcamp: yup
		.string()
		.trim()
		.max(1000, 'El campo Bandcamp no puede superar los 1000 caracteres.')
		.nullable(),
});

export const studioSchema = yup.object().shape({
	category: yup
		.string()
		.trim()
		.required('La categoría es obligatoria.')
		.max(50, 'La categoría no puede superar los 50 caracteres.'),
	title: yup
		.string()
		.trim()
		.required('El título es obligatorio.')
		.max(50, 'El título no puede superar los 50 caracteres.'),
	description: yup
		.string()
		.trim()
		.required('La descripción es obligatoria.')
		.max(2000, 'La descripción no puede superar los 2000 caracteres.'),
});

//VALIDACIONES PERSONALIZADAS PARA PROYECTOS:
export const projectFileValidations = (files, isEditMode = false) => {
	const errors = [];

	const coverEmpty =
		!files.cover ||
		(!isEditMode && !files.cover?.name) ||
		(isEditMode && !files.cover?.secure_url && !files.cover?.name);

	if (coverEmpty) {
		errors.push('La imagen de portada es obligatoria.');
	} else if (files.cover?.size > 1000000) {
		errors.push('La imagen de portada no puede superar 1MB.');
	}

	if (files.image?.size > 1000000) {
		errors.push('La imagen 1 no puede superar 1MB.');
	}

	if (files.image_2?.size > 1000000) {
		errors.push('La imagen 2 no puede superar 1MB.');
	}

	if (files.video?.size > 50000000) {
		errors.push('El vídeo no puede superar 50MB.');
	}

	if (files.audio?.size > 20000000) {
		errors.push('El audio no puede superar 20MB.');
	}

	return errors;
};

// VALIDACIONES PERSONALIZADAS PARA STUDIO
export const studioFileValidations = (files, isEditMode = false) => {
	const errors = [];

	const checkImage = (file, label) => {
		if (
			!file ||
			(!isEditMode && !file.name) ||
			(isEditMode && !file.secure_url && !file.name)
		) {
			errors.push(`La imagen ${label} es obligatoria.`);
		} else if (file.size > 1000000) {
			errors.push(`La imagen ${label} no puede superar 1MB.`);
		}
	};

	checkImage(files.image1, '1');
	checkImage(files.image2, '2');
	checkImage(files.image3, '3');

	return errors;
};
